export const locales = {
	closeBtn: 'Fermer la boîte de dialogue',
	cancelBtn: 'Annuler',
	confirmBtn: 'Valider'
};
